export default {
  attachmentPreviewsAriaLabel: 'Remove Attachment',
};
